(function () {
  const CART_KEY = "crephut-cart";
  const STORE = "https://www.crephut.com";
  const money = (n) =>
    new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n);

  const products = () => window.CREPHUT_PRODUCTS || [];
  const byId = (id) => products().find((p) => p.id === id);

  function isLiveShopify() {
    return Boolean(window.CREPHUT_LIVE) || /(?:^|\.)crephut\.com$|(?:^|\.)myshopify\.com$/.test(location.hostname);
  }

  function logoSrc() {
    const existing = document.querySelector("img.logo-img");
    if (existing && existing.getAttribute("src")) return existing.getAttribute("src");
    const raw = window.CREPHUT_LOGO || "";
    if (raw && !/crephut-logo/i.test(raw)) {
      return raw + (raw.includes("?") ? "&" : "?") + "cb=1786854001";
    }
    if (window.CREPHUT_LIVE && window.CREPHUT_ASSET_BASE) {
      return window.CREPHUT_ASSET_BASE + "logo.png?cb=1786854001";
    }
    return "images/logo.png";
  }

  function logoHTML() {
    return `<a class="logo" href="${routes().home}"><img class="logo-img" src="${logoSrc()}" alt="Crephut" width="220" height="42" decoding="async" /></a>`;
  }

  function liveHref(href) {
    if (!isLiveShopify() || !href) return href;
    if (/^https?:\/\//i.test(href) || href.startsWith("/")) return href;
    try {
      const u = new URL(href, "https://www.crephut.com/");
      const file = u.pathname.split("/").pop();
      if (file === "shop.html") return "/collections/all" + u.search;
      if (file === "product.html") {
        const id = u.searchParams.get("id");
        return id ? "/products/" + id : "/collections/all";
      }
      if (file === "index.html" || !file) return "/";
    } catch {
      /* keep */
    }
    return href;
  }

  function routes() {
    const live = isLiveShopify();
    return {
      home: live ? "/" : "index.html",
      shop: live ? "/collections/all?page=1" : "shop.html",
      product: (id) => (live ? `/products/${id}` : `product.html?id=${id}`),
      cart: live ? "/cart" : "cart.html",
      about: live ? "/pages/about-us" : "about.html",
      contact: live ? "/pages/contact-us" : "contact.html",
      reviews: live ? "/pages/reviews" : "reviews.html",
      account: live ? "/account/login" : "account.html",
    };
  }

  function sizeKey(label) {
    const m = String(label || "").match(/(\d+(?:\.\d+)?)/);
    return m ? m[1] : String(label || "").toLowerCase();
  }

  async function fetchShopifyProduct(handle) {
    const urls = [`/products/${handle}.js`, `/shopify/products/${handle}.js`, `${STORE}/products/${handle}.js`];
    for (const url of urls) {
      try {
        const res = await fetch(url);
        if (res.ok) return await res.json();
      } catch {
        /* try next */
      }
    }
    return null;
  }

  function classifyBrand(title, vendor) {
    const t = `${title || ""} ${vendor || ""}`.toLowerCase();
    if (t.includes("jordan")) return "jordan";
    if (t.includes("saucony") || t.includes("omni 9") || t.includes("omni-9")) return "saucony";
    if (t.includes("yeezy")) return "yeezy";
    if (t.includes("off-white") || t.includes("off white")) return "off-white";
    if (
      t.includes("adidas") ||
      t.includes("samba") ||
      t.includes("gazelle") ||
      t.includes("campus") ||
      t.includes("spezial") ||
      t.includes("superstar")
    ) {
      return "adidas";
    }
    if (t.includes("new balance")) return "new-balance";
    if (t.includes("nike") || t.includes("air max") || t.includes("air force") || t.includes("p-6000") || t.includes("p6000")) {
      return "nike";
    }
    if (t.includes("lace")) return "accessories";
    return String(vendor || "crephut")
      .toLowerCase()
      .replace(/\s+/g, "-");
  }

  function classifyModel(title, type) {
    const t = String(title || "").toLowerCase();
    if (t.includes("omni 9") || t.includes("omni-9") || t.includes("progrid")) return "progrid-omni-9";
    if (t.includes("p-6000") || t.includes("p6000") || t.includes("p 6000")) return "p-6000";
    if (t.includes("jordan 1") || t.includes("jordan-1")) return "jordan-1";
    if (t.includes("jordan 4") || t.includes("jordan-4")) return "jordan-4";
    if (t.includes("air max 95")) return "air-max-95";
    if (t.includes("air max 97") || t.includes("97/1")) return "air-max-97";
    if (t.includes("350")) return "350";
    if (t.includes("samba")) return "samba";
    if (t.includes("campus")) return "campus";
    if (t.includes("gazelle")) return "gazelle";
    return String(type || "")
      .toLowerCase()
      .replace(/\s+/g, "-");
  }

  function classifyBadge(raw, soldOut, title) {
    if (soldOut) return "Sold out";
    if (raw && raw.badge) return raw.badge;
    const tags = String((raw && raw.tags) || "").toLowerCase();
    const t = String(title || "").toLowerCase();
    if (tags.includes("exclusive") || t.includes("exclusive")) return "Exclusive";
    if (tags.includes("grail") || t.includes("grail")) return "Grail";
    if (/\bheat\b/.test(tags)) return "Heat";
    if (/\brare\b/.test(tags)) return "Rare";
    if (/\bgs\b/.test(tags) || /(^|[\s('])gs([\s')']|$)/i.test(title || "")) return "GS";
    if (/\bnew\b/.test(tags)) return "New";
    return "";
  }

  function mapStorefrontProduct(raw) {
    const title = raw.title || "";
    const vendor = raw.vendor || "";
    const images = (raw.images || [])
      .map((img) => (typeof img === "string" ? img : img && img.src))
      .filter(Boolean)
      .map((src) => (src.startsWith("http") ? src : `https:${src}`));
    const variants = raw.variants || [];
    const priceRaw = variants[0] && variants[0].price != null ? variants[0].price : raw.price;
    const price = Number(priceRaw);
    const soldOut = variants.length ? variants.every((v) => v.available === false) : false;
    return {
      id: raw.handle || raw.id || "",
      title,
      vendor,
      brand: classifyBrand(title, vendor),
      model: classifyModel(title, raw.product_type),
      price: Number.isFinite(price) ? price : 0,
      soldOut,
      featured: true,
      badge: classifyBadge(raw, soldOut, title),
      images,
      description: String(raw.body_html || "").replace(/<[^>]+>/g, " ").trim(),
      faceLeft: productWantsFlip({ id: raw.handle, title }),
      sizes: variants.map((v) => ({
        label: v.title,
        variantId: v.id,
        available: v.available,
      })),
    };
  }

  async function loadLiveCatalogue() {
    if (!isLiveShopify()) return;
    const mapped = [];
    for (let page = 1; page <= 20; page += 1) {
      let batch = [];
      try {
        const res = await fetch(`/products.json?limit=250&page=${page}`);
        if (!res.ok) break;
        const data = await res.json();
        batch = data.products || [];
      } catch {
        break;
      }
      batch.forEach((raw) => mapped.push(mapStorefrontProduct(raw)));
      if (batch.length < 250) break;
    }
    if (mapped.length) {
      window.CREPHUT_PRODUCTS = mapped;
      window.CREPHUT_CATALOGUE_COMPLETE = true;
    }
  }

  function matchVariant(shopProduct, size) {
    if (!shopProduct?.variants?.length) return null;
    const key = sizeKey(size);
    return (
      shopProduct.variants.find((v) => sizeKey(v.title) === key && v.available) ||
      shopProduct.variants.find((v) => sizeKey(v.title) === key) ||
      shopProduct.variants.find((v) => v.available) ||
      shopProduct.variants[0]
    );
  }

  async function resolveVariantId(handle, size) {
    const live = await fetchShopifyProduct(handle);
    const variant = matchVariant(live, size);
    return variant ? variant.id : null;
  }

  async function goToShopifyCheckout(items) {
    const lines = [];
    for (const item of items) {
      const variantId = item.variantId || (await resolveVariantId(item.id, item.size));
      if (variantId) lines.push({ id: Number(variantId), quantity: item.qty });
    }
    if (!lines.length) {
      toast("Couldn't reach checkout — email info@crephut.com");
      return;
    }
    if (isLiveShopify()) {
      try {
        await fetch("/cart/clear.js", { method: "POST" });
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: lines }),
        });
        location.href = "/checkout";
        return;
      } catch {
        /* fall through to permalink */
      }
    }
    const permalink = lines.map((l) => `${l.id}:${l.quantity}`).join(",");
    location.href = `${STORE}/cart/${permalink}`;
  }

  function readCart() {
    try {
      return JSON.parse(localStorage.getItem(CART_KEY) || "[]");
    } catch {
      return [];
    }
  }

  function writeCart(items) {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
    renderCartCount();
    renderCartDrawer();
  }

  function cartCount() {
    return readCart().reduce((sum, i) => sum + i.qty, 0);
  }

  function cartTotal() {
    return readCart().reduce((sum, i) => {
      const p = byId(i.id);
      return sum + (p ? p.price * i.qty : 0);
    }, 0);
  }

  async function addToCart(id, size, qty, variantId) {
    const p = byId(id) || { title: id, soldOut: false };
    if (p.soldOut) return;
    const resolved = variantId || (await resolveVariantId(id, size));
    const items = readCart();
    const found = items.find((i) => i.id === id && i.size === size);
    if (found) {
      found.qty += qty;
      if (resolved) found.variantId = resolved;
    } else items.push({ id, size, qty, variantId: resolved });
    writeCart(items);
    toast(`${p.title} added to bag`);
    openDrawer();
  }

  function setQty(id, size, qty) {
    let items = readCart();
    if (qty <= 0) items = items.filter((i) => !(i.id === id && i.size === size));
    else items = items.map((i) => (i.id === id && i.size === size ? { ...i, qty } : i));
    writeCart(items);
    if (document.getElementById("cart-page")) renderCartPage();
  }

  function toast(msg) {
    let el = document.querySelector(".toast");
    if (!el) {
      el = document.createElement("div");
      el.className = "toast";
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add("is-on");
    clearTimeout(toast._t);
    toast._t = setTimeout(() => el.classList.remove("is-on"), 2200);
  }

  function icon(name) {
    const paths = {
      search:
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>',
      user: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="8" r="3.2"/><path d="M5 19c1.6-3 4.1-4.5 7-4.5S17.4 16 19 19"/></svg>',
      bag: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 8h12l-1 13H7L6 8z"/><path d="M9 8V7a3 3 0 0 1 6 0v1"/></svg>',
      menu: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 7h16M4 12h16M4 17h16"/></svg>',
      close:
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    };
    return paths[name] || "";
  }

  function headerHTML(page) {
    const active = (href) => (page === href ? "is-active" : "");
    return `
      <div class="announce"><div class="announce-track">
        ${["Authenticated pairs · Expert sourced since 2014","Express delivery available across the UK","Members access to exclusive drops","Email info@crephut.com to source a pair","Worldwide shipping · 24/7 assistance"].map((t) => `<span>${t}</span>`).join("").repeat(2)}
      </div></div>
      <header class="header">
        <div class="wrap header-main">
          <div>
            <button class="icon-btn menu-toggle" data-open="nav" aria-label="Menu">${icon("menu")}</button>
            <button type="button" class="search-open js-search" data-open="search" data-search-open aria-label="Search">${icon("search")}<span class="desktop-only">Search</span></button>
          </div>
          ${logoHTML()}
          <div class="header-utils">
            <a class="icon-btn" href="${routes().account}" aria-label="Account">${icon("user")}</a>
            <button class="icon-btn" data-open="cart" aria-label="Bag">${icon("bag")}<span class="bag-count">0</span></button>
          </div>
        </div>
        <nav class="nav wrap">
          <a class="${active("shop")}" href="${routes().shop}">Latest arrivals</a>
          <a class="${active("jordan")}" href="${routes().shop}?brand=jordan">Jordan</a>
          <a class="${active("nike")}" href="${routes().shop}?brand=nike">Nike</a>
          <a class="${active("saucony")}" href="${routes().shop}?brand=saucony">Saucony</a>
          <a class="${active("yeezy")}" href="${routes().shop}?brand=yeezy">Yeezy</a>
          <a class="${active("adidas")}" href="${routes().shop}?brand=adidas">Adidas</a>
          <a href="${routes().shop}?model=p-6000">P-6000</a>
          <a href="${routes().shop}?model=air-max-97">Air Max</a>
          <a href="${routes().shop}?brand=off-white">Off-White</a>
          <a href="${routes().about}">The house</a>
          <a class="sale" href="${routes().shop}?brand=jordan">Sale</a>
        </nav>
      </header>
      <div class="overlay" data-close></div>
      <div class="drawer-clip">
      <aside class="drawer" id="cart-drawer">
        <div class="drawer-head"><span>Your bag</span><button data-close aria-label="Close">${icon("close")}</button></div>
        <div class="drawer-body" id="cart-drawer-body"></div>
        <div class="drawer-foot">
          <p style="display:flex;justify-content:space-between"><span>Subtotal</span><strong id="cart-sub">£0.00</strong></p>
          <button class="btn" data-checkout style="width:100%;margin-bottom:10px">Checkout</button>
          <a class="btn btn-ghost dark" href="${routes().cart}" style="width:100%">View bag</a>
        </div>
      </aside>
      </div>
      <div class="drawer-clip">
      <aside class="mobile-nav" id="mobile-nav">
        <div class="drawer-head"><span>Menu</span><button data-close aria-label="Close">${icon("close")}</button></div>
        <a href="${routes().shop}">Latest arrivals</a>
        <a href="${routes().shop}?brand=jordan">Jordan</a>
        <a href="${routes().shop}?brand=nike">Nike</a>
        <a href="${routes().shop}?brand=saucony">Saucony</a>
        <a href="${routes().shop}?brand=yeezy">Yeezy</a>
        <a href="${routes().shop}?brand=adidas">Adidas</a>
        <a href="${routes().shop}?model=p-6000">P-6000</a>
        <a href="${routes().shop}?model=air-max-97">Air Max</a>
        <a href="${routes().about}">About</a>
        <a href="${routes().reviews}">Reviews</a>
        <a href="${routes().contact}">Contact</a>
        <a href="${routes().account}">Account</a>
      </aside>
      </div>
      <div class="search-modal" id="search-modal" aria-hidden="true" role="dialog" aria-label="Search the hut">
        <div class="wrap" style="padding-top:28px">
          <div class="search-head"><span>Search the hut</span><button type="button" class="search-close search-x" data-search-close data-close-search data-close aria-label="Close search">${icon("close")}</button></div>
          <input id="search-input" class="search-field" type="text" inputmode="search" autocomplete="off" autocorrect="off" spellcheck="false" placeholder="Jordan 4, Patta, Yeezy…" />
          <div id="search-results" class="grid-products"></div>
        </div>
      </div>
    `;
  }

  function footerHTML() {
    return `
      <section class="news">
        <div class="wrap">
          <p class="eyebrow">Members list</p>
          <h2>First look at what lands.</h2>
          <p class="muted">Drops, restocks and sourced grails — no noise.</p>
          <form class="news-form" data-newsletter>
            <input type="email" required placeholder="Email address" />
            <button class="btn" type="submit">Join</button>
          </form>
        </div>
      </section>
      <footer class="footer">
        <div class="wrap footer-grid">
          <div>
            ${logoHTML()}
            <p>Founded in 2014. A legitimate outlet for footwear connoisseurs — limited pairs, specialist colourways, sourced worldwide.</p>
          </div>
          <div>
            <h4>Shop</h4>
            <ul>
              <li><a href="${routes().shop}">Latest arrivals</a></li>
              <li><a href="${routes().shop}?brand=jordan">Air Jordan</a></li>
              <li><a href="${routes().shop}?brand=nike">Nike</a></li>
              <li><a href="${routes().shop}?brand=saucony">Saucony</a></li>
              <li><a href="${routes().shop}?brand=yeezy">Yeezy</a></li>
              <li><a href="${routes().shop}?brand=adidas">Adidas</a></li>
              <li><a href="${routes().shop}?brand=off-white">Off-White</a></li>
            </ul>
          </div>
          <div>
            <h4>House</h4>
            <ul>
              <li><a href="${routes().about}">About us</a></li>
              <li><a href="${routes().reviews}">Reviews</a></li>
              <li><a href="${routes().contact}">Contact</a></li>
              <li><a href="${routes().account}">Account</a></li>
            </ul>
          </div>
          <div>
            <h4>Contact</h4>
            <ul>
              <li><a href="mailto:info@crephut.com">info@crephut.com</a></li>
              <li>Assistance 24/7</li>
              <li>Company no. 09783267</li>
            </ul>
          </div>
        </div>
        <div class="wrap footer-bottom">
          <span>© ${new Date().getFullYear()} Crephut. All rights reserved.</span>
          <span>Visa · Mastercard · Amex · PayPal · GBP</span>
        </div>
      </footer>
    `;
  }

  const FACE_LEFT_IDS = new Set([
    "air-jordan-4-retro-red-cement",
    "air-jordan-retro-4-bred-2019",
  ]);

  function productWantsFlip(p) {
    if (!p) return false;
    if (p.faceLeft === true || p.face === "left") return true;
    if (FACE_LEFT_IDS.has(String(p.id || ""))) return true;
    const t = String(p.title || "").toLowerCase();
    if (t.includes("red cement")) return true;
    if (t.includes("bred") && t.includes("2019") && (t.includes("4") || t.includes("jordan"))) return true;
    return false;
  }

  function shotFaceBits(p) {
    if (!productWantsFlip(p)) return { cls: "", attr: "" };
    return { cls: " face-left", attr: ' data-face-left="1"' };
  }

  function shotSrc(src) {
    if (!src) return src;
    const abs = src.startsWith("//") ? "https:" + src : src;
    if (isLiveShopify()) return abs;
    try {
      const u = new URL(abs, location.href);
      if (u.hostname === "www.crephut.com" || u.hostname === "cdn.shopify.com") {
        return "/shopify/img?u=" + encodeURIComponent(abs);
      }
    } catch {
      /* keep original */
    }
    return src;
  }

  function mediaSrc(src) {
    if (!src || src.startsWith("data:")) return src;
    const remote = /^(https?:)?\/\//i.test(src) || src.startsWith("/cdn") || src.startsWith("/shopify");
    if (!remote && window.CREPHUT_LIVE && window.CREPHUT_ASSET_BASE) {
      return window.CREPHUT_ASSET_BASE + src.split("/").pop();
    }
    return shotSrc(src);
  }

  const PAPER_PLACEHOLDER =
    "data:image/svg+xml;charset=utf-8," +
    encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="800" height="800"><rect width="100%" height="100%" fill="#f6f3ee"/></svg>');

  function esc(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function cardHTML(p) {
    p = p || {};
    const title = p.title || p.name || "Untitled";
    const vendor = String(p.vendor || p.brand || "").replace(/-/g, " ");
    const badge = p.soldOut ? "Sold out" : p.badge || "";
    const face = shotFaceBits(p);
    const images = Array.isArray(p.images) ? p.images : [];
    const src = mediaSrc(images[0]) || PAPER_PLACEHOLDER;
    const price = p.soldOut ? "Sold out" : money(Number(p.price) || 0);
    const id = p.id || p.handle || "";
    return `
      <article class="card product-card" data-id="${esc(id)}">
        <a href="${esc(routes().product(id))}">
          <div class="card-media">
            ${badge ? `<span class="badge card-badge ${p.soldOut ? "out" : ""}">${esc(badge)}</span>` : ""}
            <img class="product-shot${face.cls}" src="${esc(src)}" alt="${esc(title)}"${face.attr} onerror="this.onerror=null;this.src='${PAPER_PLACEHOLDER}'" />
          </div>
          <div class="card-body">
            <p class="card-brand">${esc(vendor)}</p>
            <h3 class="card-title">${esc(title)}</h3>
            <p class="card-price">${esc(price)}</p>
          </div>
        </a>
      </article>
    `;
  }

  function renderProducts(el, list) {
    if (!el) return;
    el.innerHTML = list.length
      ? list
          .map((item) => {
            try {
              return cardHTML(item);
            } catch {
              return cardHTML({
                id: item && item.id,
                title: (item && (item.title || item.name)) || "Untitled",
                vendor: (item && (item.vendor || item.brand)) || "",
                price: (item && item.price) || 0,
                images: [],
              });
            }
          })
          .join("")
      : `<p class="empty">No pairs match those filters.</p>`;
  }

  function renderCartCount() {
    document.querySelectorAll(".bag-count").forEach((n) => (n.textContent = cartCount()));
  }

  function renderCartDrawer() {
    const body = document.getElementById("cart-drawer-body");
    const sub = document.getElementById("cart-sub");
    if (!body) return;
    const items = readCart();
    if (!items.length) {
      body.innerHTML = `<p class="empty">Your bag is empty. <a class="link-arrow" href="${routes().shop}">Continue shopping</a></p>`;
    } else {
      body.innerHTML = items
        .map((i) => {
          const p = byId(i.id);
          if (!p) return "";
          return `<div class="cart-item" style="grid-template-columns:72px 1fr">
            <img class="product-shot${shotFaceBits(p).cls}" src="${mediaSrc(p.images[0])}" alt=""${shotFaceBits(p).attr} />
            <div>
              <strong>${p.title}</strong>
              <p class="muted">UK ${i.size} · ${money(p.price)}</p>
              <div class="qty">
                <button data-qty="${i.id}|${i.size}|${i.qty - 1}">−</button>
                <span style="padding:0 8px">${i.qty}</span>
                <button data-qty="${i.id}|${i.size}|${i.qty + 1}">+</button>
              </div>
            </div>
          </div>`;
        })
        .join("");
    }
    if (sub) sub.textContent = money(cartTotal());
  }

  function renderCartPage() {
    const el = document.getElementById("cart-page-items");
    if (!el) return;
    const items = readCart();
    if (!items.length) {
      el.innerHTML = `<p class="empty">Your bag is currently empty.</p>`;
    } else {
      el.innerHTML = items
        .map((i) => {
          const p = byId(i.id);
          if (!p) return "";
          return `<div class="cart-item">
            <img class="product-shot${shotFaceBits(p).cls}" src="${mediaSrc(p.images[0])}" alt=""${shotFaceBits(p).attr} />
            <div>
              <p class="card-brand">${p.brand}</p>
              <h3 class="card-title">${p.title}</h3>
              <p class="muted">UK ${i.size}</p>
              <div class="qty">
                <button data-qty="${i.id}|${i.size}|${i.qty - 1}">−</button>
                <span style="padding:0 8px">${i.qty}</span>
                <button data-qty="${i.id}|${i.size}|${i.qty + 1}">+</button>
              </div>
            </div>
            <strong>${money(p.price * i.qty)}</strong>
          </div>`;
        })
        .join("");
    }
    const t = document.getElementById("cart-total");
    if (t) t.textContent = money(cartTotal());
  }

  function openDrawer() {
    document.querySelector(".overlay")?.classList.add("is-on");
    document.getElementById("cart-drawer")?.classList.add("is-on");
  }

  function searchInputEl() {
    const open = document.querySelector(".search-modal.is-on, .search-modal.is-open");
    return (
      open?.querySelector("#search-input, .search-field, input, textarea") ||
      document.getElementById("search-input") ||
      document.querySelector(".search-modal input, .search-field")
    );
  }

  function focusSearchInput() {
    const input = searchInputEl();
    if (!input) return;
    try {
      input.focus({ preventScroll: true });
    } catch (err) {
      input.focus();
    }
  }

  function openSearch() {
    const modal = document.getElementById("search-modal") || document.querySelector(".search-modal");
    if (!modal) return;
    document.querySelector(".overlay")?.classList.remove("is-on");
    document.getElementById("cart-drawer")?.classList.remove("is-on");
    document.getElementById("mobile-nav")?.classList.remove("is-on");
    modal.classList.add("is-on", "is-open");
    modal.removeAttribute("hidden");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("search-lock");
    document.body.style.overflow = "hidden";
    const input = searchInputEl();
    const results = modal.querySelector("#search-results") || document.getElementById("search-results");
    if (results) results.innerHTML = "";
    if (input) input.value = "";
    focusSearchInput();
    requestAnimationFrame(() => {
      focusSearchInput();
      requestAnimationFrame(focusSearchInput);
    });
    setTimeout(focusSearchInput, 50);
  }

  function closeSearch() {
    document.querySelectorAll(".search-modal").forEach((modal) => {
      modal.classList.remove("is-on", "is-open");
      modal.setAttribute("aria-hidden", "true");
    });
    document.body.classList.remove("search-lock");
    document.body.style.overflow = "";
    searchInputEl()?.blur();
  }

  function closeAll() {
    document.querySelector(".overlay")?.classList.remove("is-on");
    document.getElementById("cart-drawer")?.classList.remove("is-on");
    document.getElementById("mobile-nav")?.classList.remove("is-on");
    closeSearch();
  }

  function searchQuery(value) {
    const raw = String(value || "").trim();
    if (!raw) return "";
    const placeholder = (document.getElementById("search-input")?.getAttribute("placeholder") || "").trim();
    if (raw.toLowerCase() === placeholder.toLowerCase()) return "";
    return raw.toLowerCase();
  }

  function runSearch(value) {
    const el = document.getElementById("search-results");
    if (!el) return;
    const q = searchQuery(value);
    if (!q) {
      el.innerHTML = "";
      return;
    }
    const list = products().filter((p) => String(p.title || "").toLowerCase().includes(q)).slice(0, 8);
    renderProducts(el, list);
  }

  const SEARCH_CLOSE = "[data-search-close], [data-close-search], .search-close, .search-x, #search-modal [data-close], #search-modal .search-head button";
  const SEARCH_OPEN = "[data-search-open], .js-search, .search-open, [data-open='search']";

  document.addEventListener(
    "click",
    (e) => {
      if (e.target.closest(SEARCH_CLOSE)) {
        e.preventDefault();
        closeSearch();
        return;
      }
      if (e.target.closest(SEARCH_OPEN)) {
        e.preventDefault();
        openSearch();
      }
    },
    true
  );
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeSearch();
  });
  document.addEventListener("input", (e) => {
    const t = e.target;
    if (t && (t.id === "search-input" || t.classList.contains("search-field"))) runSearch(t.value);
  });

  function params() {
    return new URLSearchParams(location.search);
  }

  function filterProducts() {
    const q = params();
    let list = products();
    const brand = q.get("brand");
    const model = q.get("model");
    const search = (q.get("q") || "").toLowerCase();
    if (brand) list = list.filter((p) => p.brand === brand);
    if (model) list = list.filter((p) => p.model === model);
    if (search) list = list.filter((p) => String(p.title || "").toLowerCase().includes(search));
    return list;
  }

  function isNewArrival(p) {
    return String(p.badge || "").toLowerCase() === "new";
  }

  function latestArrivalProducts(limit) {
    const list = products();
    const fresh = list.filter((p) => isNewArrival(p) || p.featured);
    const news = fresh.filter(isNewArrival);
    const rest = fresh.filter((p) => !isNewArrival(p));
    return [...news, ...rest].slice(0, limit);
  }

  function moreFromHut(exclude, limit) {
    const skip = new Set((exclude || []).map((p) => p.id));
    return products().filter((p) => !skip.has(p.id)).slice(0, limit);
  }

  function trustpilotUrl() {
    return window.CREPHUT_TRUSTPILOT || "https://www.trustpilot.com/review/crephut.com";
  }

  function nextReviewIndex(reviews) {
    const n = reviews.length;
    if (!n) return 0;
    let i = 0;
    try {
      i = parseInt(localStorage.getItem("ch-review-i") || "0", 10);
      if (!Number.isFinite(i) || i < 0) i = 0;
    } catch {
      /* private mode */
    }
    const idx = i % n;
    try {
      localStorage.setItem("ch-review-i", String(i + 1));
    } catch {
      /* private mode */
    }
    return idx;
  }

  function featuredReview() {
    const reviews = window.CREPHUT_REVIEWS || [];
    const index = nextReviewIndex(reviews);
    return { reviews, index, review: reviews[index] || null };
  }

  function reviewCite(r) {
    return [r.name, r.location].filter(Boolean).join(" · ");
  }

  function quoteMarkup(r) {
    if (!r) return "";
    return `<blockquote class="quote">“${r.text}”</blockquote>
      <cite class="quote-meta">${reviewCite(r)}</cite>
      <p class="quote-trust"><a href="${trustpilotUrl()}" target="_blank" rel="noopener noreferrer">Rated on Trustpilot</a></p>`;
  }

  function initHome() {
    const stories = document.getElementById("stories");
    if (stories) {
      stories.innerHTML = (window.CREPHUT_STORIES || [])
        .map(
          (s) => `<a class="story" href="${liveHref(s.href)}">
            <div class="story-ring"><span class="story-hole"><img src="${mediaSrc(s.image)}" alt="${s.label}" /></span></div>
            ${s.label}
          </a>`
        )
        .join("");
    }

    const arrivals = latestArrivalProducts(8);
    renderProducts(document.getElementById("new-arrivals"), arrivals);
    renderProducts(document.getElementById("just-in"), moreFromHut(arrivals, 8));

    const slides = [...document.querySelectorAll(".hero-slide")];
    const dots = [...document.querySelectorAll(".hero-dots button")];
    let i = 0;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle("is-on", idx === i));
      dots.forEach((d, idx) => d.classList.toggle("is-on", idx === i));
    };
    dots.forEach((d, idx) => d.addEventListener("click", () => show(idx)));
    if (slides.length) setInterval(() => show(i + 1), 6500);

    const quote = document.getElementById("home-quote");
    if (quote) {
      const picked = featuredReview();
      if (picked.review) quote.innerHTML = quoteMarkup(picked.review);
    }
  }

  function initShop() {
    const grid = document.getElementById("shop-grid");
    if (!grid) return;
    const apply = () => {
      const sort = document.getElementById("sort")?.value || "featured";
      let list = filterProducts();
      if (sort === "price-asc") list = [...list].sort((a, b) => a.price - b.price);
      if (sort === "price-desc") list = [...list].sort((a, b) => b.price - a.price);
      if (sort === "az") list = [...list].sort((a, b) => a.title.localeCompare(b.title));
      renderProducts(grid, list);
      const pages = document.querySelector(".shop-pages");
      if (pages && window.CREPHUT_CATALOGUE_COMPLETE) pages.hidden = true;
      const count = document.getElementById("shop-count");
      if (count) count.textContent = `${list.length} pairs`;
    };
    document.getElementById("sort")?.addEventListener("change", apply);
    document.querySelectorAll("[data-filter]").forEach((input) => {
      input.addEventListener("change", () => {
        const url = new URL(location.href);
        if (input.checked) url.searchParams.set(input.dataset.filter, input.value);
        else url.searchParams.delete(input.dataset.filter);
        history.replaceState({}, "", url);
        apply();
      });
    });
    const brand = params().get("brand");
    if (brand) {
      const box = document.querySelector(`[data-filter="brand"][value="${brand}"]`);
      if (box) box.checked = true;
    }
    const model = params().get("model");
    if (model) {
      const box = document.querySelector(`[data-filter="model"][value="${model}"]`);
      if (box) box.checked = true;
    }
    apply();
  }

  async function initPDP() {
    const root = document.getElementById("pdp");
    if (!root) return;
    const handle = params().get("id") || window.CREPHUT_HANDLE;
    let p = byId(handle);
    const live = handle ? await fetchShopifyProduct(handle) : null;
    if (live) {
      const price = (live.price || 0) / 100;
      const faceLeft = productWantsFlip(p) || productWantsFlip({ id: live.handle, title: live.title });
      p = {
        id: live.handle,
        title: live.title,
        brand: (live.vendor || "crephut").toLowerCase(),
        price,
        soldOut: !live.available,
        images: (live.images || []).map((src) => (src.startsWith("http") ? src : `https:${src}`)),
        description: (live.description || "").replace(/<[^>]+>/g, " ").trim() || p?.description || "",
        faceLeft,
        face: faceLeft ? "left" : undefined,
        sizes: (live.variants || []).map((v) => ({
          label: v.title,
          variantId: v.id,
          available: v.available,
        })),
      };
    }
    if (!p) {
      root.innerHTML = `<p class="empty">This pair could not be found. <a href="${routes().shop}">Back to shop</a></p>`;
      return;
    }
    const sizeOpts = Array.isArray(p.sizes)
      ? p.sizes.map((s) => (typeof s === "object" ? s : { label: s, variantId: null, available: !p.soldOut }))
      : [];
    document.title = `${p.title} — Crephut`;
    root.innerHTML = `
      <div class="pdp-gallery"><img class="product-shot${shotFaceBits(p).cls}" src="${mediaSrc(p.images[0])}" alt="${p.title}"${shotFaceBits(p).attr} /></div>
      <div class="pdp-info">
        <div class="pdp-title-block">
          <p class="crumbs pdp-crumbs"><a href="${routes().home}">Home</a> / <a href="${routes().shop}">Shop</a> / ${p.brand}</p>
          <p class="eyebrow pdp-brand">${String(p.brand).replace("-", " ")} ${p.badge ? "· " + p.badge : ""}</p>
          <h1 class="pdp-title">${p.title}</h1>
          <p class="pdp-price">${p.soldOut ? "Sold out" : money(p.price)}</p>
        </div>
        <p class="pdp-desc">${p.description}</p>
        <p style="margin-top:24px" class="eyebrow">Select UK size</p>
        <div class="sizes pdp-sizes" id="sizes">
          ${sizeOpts
            .map(
              (s) =>
                `<button class="size ${s.available ? "" : "is-off"}" data-size="${s.label}" data-variant="${s.variantId || ""}" ${s.available ? "" : "disabled"}>${s.label.replace(/^UK\s*/i, "")}</button>`
            )
            .join("")}
        </div>
        <div class="btn-row pdp-actions">
          <button class="btn" id="add-bag" ${p.soldOut ? "disabled" : ""}>${p.soldOut ? "Notify me" : "Add to bag"}</button>
          <a class="btn btn-ghost dark" href="${routes().contact}">Source a size</a>
        </div>
        <div class="pdp-meta">
          <div><strong>Authenticated.</strong> Every pair is checked before it leaves the hut.</div>
          <div><strong>Sourced worldwide.</strong> Direct from manufacturers and trusted distributors since 2014.</div>
          <div><strong>Need a pair we don't list?</strong> Email info@crephut.com — we'll try to find it.</div>
        </div>
      </div>
    `;
    let size = sizeOpts.find((s) => s.available) || sizeOpts[0];
    root.querySelectorAll(".size").forEach((btn, idx) => {
      if (size && btn.dataset.size === String(size.label)) btn.classList.add("is-on");
      else if (!size && idx === 0) btn.classList.add("is-on");
      btn.addEventListener("click", () => {
        root.querySelectorAll(".size").forEach((b) => b.classList.remove("is-on"));
        btn.classList.add("is-on");
        size = { label: btn.dataset.size, variantId: btn.dataset.variant ? Number(btn.dataset.variant) : null };
      });
    });
    document.getElementById("add-bag")?.addEventListener("click", () => {
      if (p.soldOut) return toast("We'll email you when this returns");
      addToCart(p.id, size?.label, 1, size?.variantId);
    });
    renderProducts(
      document.getElementById("related"),
      products().filter((x) => x.brand === p.brand && x.id !== p.id).slice(0, 4)
    );
  }

  function initReviews() {
    const el = document.getElementById("reviews-list");
    const featured = document.getElementById("reviews-featured");
    if (!el && !featured) return;
    const picked = featuredReview();
    if (featured && picked.review) featured.innerHTML = quoteMarkup(picked.review);
    if (!el) return;
    el.innerHTML = picked.reviews
      .map(
        (r, idx) => `<article class="review${idx === picked.index ? " is-featured" : ""}">
          <div class="stars">${"★".repeat(r.rating)}${"☆".repeat(5 - r.rating)}</div>
          <p>${r.text}</p>
          <p class="quote-meta" style="text-align:left">${reviewCite(r)}</p>
        </article>`
      )
      .join("");
  }

  function bindChrome() {
    document.addEventListener("click", (e) => {
      if (e.target.closest("[data-close], [data-close-search], [data-search-close], .search-close, .search-x")) {
        e.preventDefault();
        closeAll();
        return;
      }
      const modal = document.getElementById("search-modal");
      if (modal?.classList.contains("is-on") && (e.target === modal || e.target.classList.contains("search-modal"))) {
        closeSearch();
        return;
      }
      const open = e.target.closest("[data-open]");
      if (open) {
        const which = open.dataset.open;
        if (which === "cart") {
          document.querySelector(".overlay").classList.add("is-on");
          document.getElementById("cart-drawer").classList.add("is-on");
        }
        if (which === "nav") {
          document.querySelector(".overlay").classList.add("is-on");
          document.getElementById("mobile-nav").classList.add("is-on");
        }
        if (which === "search") {
          openSearch();
        }
      }
      if (e.target.closest("[data-checkout]")) {
        e.preventDefault();
        const items = readCart();
        if (!items.length) return toast("Your bag is empty");
        toast("Taking you to secure checkout…");
        goToShopifyCheckout(items);
        return;
      }
      const qty = e.target.closest("[data-qty]");
      if (qty) {
        const [id, size, n] = qty.dataset.qty.split("|");
        setQty(id, size, Number(n));
      }
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeAll();
    });
    document.getElementById("search-input")?.addEventListener("input", (e) => {
      runSearch(e.target.value);
    });
    document.querySelectorAll("[data-newsletter]").forEach((form) => {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        toast("You're on the list");
        form.reset();
      });
    });
    document.querySelectorAll("[data-contact]").forEach((form) => {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        toast("Message received — we'll be in touch");
        form.reset();
      });
    });
    document.querySelectorAll("[data-account]").forEach((form) => {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        toast("Welcome back to the hut");
      });
    });
  }

  async function mount() {
    document.body.classList.add("site");
    const page = document.body.dataset.page || "";
    const shell = document.getElementById("site-chrome");
    if (shell && !shell.querySelector("img.logo-img")) {
      shell.insertAdjacentHTML("afterbegin", headerHTML(page));
    }
    const foot = document.getElementById("site-footer");
    if (foot) foot.innerHTML = footerHTML();
    bindChrome();
    renderCartCount();
    renderCartDrawer();
    await loadLiveCatalogue();
    initHome();
    initShop();
    initPDP();
    initReviews();
    renderCartPage();
  }

  document.addEventListener("DOMContentLoaded", mount);
})();
